import { createContext, useContext } from 'react';

/**
 * Opens a node's config form in the editor inspector by its workflow node id.
 *
 * Clicking a card goes through `onNodeClick`, which already has the card's view
 * data — but some nodes have no card on the canvas. A for-each loop body is
 * hidden inside its loop, so the only way to reach it is from the for-each
 * editor; without this it can be attached but never configured (you can wire a
 * tool call as the body but can't set its inputs). The provider resolves the
 * node from the live graph and drills the inspector into it.
 *
 * Provided by the editor canvas only. The read-only run graph leaves it null.
 */
export type WorkflowOpenNodeConfig = (nodeId: string) => void;

const WorkflowOpenNodeConfigContext =
  createContext<WorkflowOpenNodeConfig | null>(null);

export const WorkflowOpenNodeConfigProvider =
  WorkflowOpenNodeConfigContext.Provider;

export const useWorkflowOpenNodeConfig = (): WorkflowOpenNodeConfig | null =>
  useContext(WorkflowOpenNodeConfigContext);
